import styled from '@emotion/styled'

export const KeywordContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 400px;
  width: 80vw;
  max-width: 800px;
`

export const SelectorWrapper = styled.div`
  width: 410px;
`

export const KeywordTitle = styled.h1`
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 0 !important;
`

export const KeywordDescription = styled.p`
  font-size: 14px;
  margin-bottom: 10px;
`
